var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-up-bt-container",class:[_vm.isShow ? 'show' : ''],on:{"click":_vm.backToTop}},[_c('p',[_vm._v("back top")]),_c('div',{staticClass:"line"},[_c('div',{staticClass:"line__inner",style:({
        backgroundColor: _vm.lineColor
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }